import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

/**
 * Run AI analysis on an existing completed analysis.
 * @param {number} analysisId - The AnalysisWrapper ID.
 * @param {object} aiParams - AI parameters: clinical_history, hpos, hpo_names, diseases, disease_ids, user_guidance
 * @returns {Promise<object>} The response data: { new_balance, deducted_amount } or { error, needed_balance }
 */
export const runAIOnAnalysis = async (analysisId, aiParams) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/analysis/${analysisId}/run-ai/`, aiParams)
    return data
  } catch (error) {
    if (error.response) {
      if (error.response.status === 402) {
        return {
          error: 'Insufficient balance',
          needed_balance: error.response.data.needed_balance,
        }
      }
      if (error.response.status === 409) {
        return {
          error: 'Pipeline is still running.',
        }
      }
      if (error.response.status === 400) {
        return {
          error: error.response.data.error || 'Bad request',
        }
      }
    }
    throw error
  }
}
